import { combineReducers } from "redux";
import settingReducer from "./settingsSlice";
import profileReducer from "./profileSlice";
import authSlice from "./authSlice";
import messageSlice from "./messageSlice";
import permissionSlice from "./permissionSlice";

const rootReducer = combineReducers({
  profile: profileReducer,
  setting: settingReducer,
  authProvider: authSlice,
  message: messageSlice,
  permission: permissionSlice,
});

export default rootReducer;
